/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaRootMiniReference,
    MediaRootMiniReferenceFromJSON,
    MediaRootMiniReferenceFromJSONTyped,
    MediaRootMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SavedSearchUpdate
 */
export interface SavedSearchUpdate {
    /**
     * 
     * @type {MediaRootMiniReference}
     * @memberof SavedSearchUpdate
     */
    root?: MediaRootMiniReference;
    /**
     * 
     * @type {Array<string>}
     * @memberof SavedSearchUpdate
     */
    query: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SavedSearchUpdate
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof SavedSearchUpdate
     */
    shared?: boolean;
}

export function SavedSearchUpdateFromJSON(json: any): SavedSearchUpdate {
    return SavedSearchUpdateFromJSONTyped(json, false);
}

export function SavedSearchUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedSearchUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'root': !exists(json, 'root') ? undefined : MediaRootMiniReferenceFromJSON(json['root']),
        'query': json['query'],
        'name': json['name'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
    };
}

export function SavedSearchUpdateToJSON(value?: SavedSearchUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'root': MediaRootMiniReferenceToJSON(value.root),
        'query': value.query,
        'name': value.name,
        'shared': value.shared,
    };
}


